export default __webpack_public_path__ + "static/media/surfmappers.83762cb7.jpg";